module.exports = __webpack_public_path__ + "static/img/v_4.50c564f1.png";